import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import pdfMake from "pdfmake/build/pdfmake"
import * as pdfFonts from "pdfmake/build/vfs_fonts" // Use namespace import to ensure vfs is available
import { buildInspectionSectionsContent } from "./sectionContent"
import { InspectionDocumentsParameters } from "../Crud/parameters"
import { post } from "helpers/api_helper"

import { FaFilePdf } from "react-icons/fa"
import { Button } from "reactstrap"
import { footerImage, headerImage, verifiedImage, qrImage } from "assets/images"
import { updateInspection } from "store/actions"
import { useHistory, useParams } from "react-router-dom"
import { useDispatch } from "react-redux"
import InspectionPDFDownloadModal from "./pdfModal"
import { spaceGrotesk } from "assets/fonts/spaceGrotesk"
import { spaceGroteskBold } from "assets/fonts/spaceGroteskBold"
import moment from "moment"

const inspectionSections = [
  {
    title: "1. Vehicle History",
    data: InspectionDocumentsParameters?.vehicleHistory?.items,
    checkMetricIndex: 0,
    isSub: false,
  },
  {
    title: "2. Road Test",
    data: InspectionDocumentsParameters?.roadTest?.items,
    checkMetricIndex: 1,
    isSub: false,
  },
  {
    title: "3. Vehicle Exterior",
    data: InspectionDocumentsParameters?.vehicleExterior?.subHeads,
    checkMetricIndex: 2,
    isSub: true,
  },
  {
    title: "4. Vehicle Interior",
    data: InspectionDocumentsParameters?.vehicleInterior?.subHeads,
    checkMetricIndex: 3,
    isSub: true,
  },
  {
    title: "5. Vehicle Diagnostic",
    data: InspectionDocumentsParameters?.vehicleDiagnostics?.items,
    checkMetricIndex: 4,
  },
  {
    title: "6. Underhood Components",
    data: InspectionDocumentsParameters?.underhoodComponents?.subHeads,
    checkMetricIndex: 5,
    isSub: true,
  },
  {
    title: "7. UnderBody Components",
    data: InspectionDocumentsParameters?.underbodyComponents?.subHeads,
    checkMetricIndex: 6,
    isSub: true,
  },
  {
    title: "8. Final Check",
    data: InspectionDocumentsParameters?.finalChecks?.items,
    checkMetricIndex: 7,
    isSub: false,
  },
]

const getGlobalIndex = (sectionIdx, subHeadIdx, itemIdx) => {
  let count = 0
  for (let i = 0; i < sectionIdx; i++) {
    const sec = inspectionSections[i]
    if (sec.isSub && Array.isArray(sec.data)) {
      sec.data.forEach(sub => {
        count += sub.item.length
      })
    } else if (Array.isArray(sec.data)) {
      count += sec.data.length
    }
  }
  // Add previous subHeads in this section
  if (subHeadIdx !== undefined) {
    for (let j = 0; j < subHeadIdx; j++) {
      count +=
        sectionIdx >= 0 && inspectionSections[sectionIdx].data[j].item.length
    }
    count += itemIdx
  } else {
    count += itemIdx
  }
  return count + 1
}
// Assign vfs, handling both possible export shapes
pdfMake.vfs = pdfFonts
pdfMake.vfs["SpaceGrotesk-Regular.ttf"] = spaceGrotesk
pdfMake.vfs["SpaceGrotesk-Bold.ttf"] = spaceGroteskBold

pdfMake.fonts = {
  ...pdfMake.fonts,
  SpaceGrotesk: {
    normal: "SpaceGrotesk-Regular.ttf",
    bold: "SpaceGrotesk-Bold.ttf",
    italics: "SpaceGrotesk-Regular.ttf", // Replace with italic if available
    bolditalics: "SpaceGrotesk-Bold.ttf", // Replace with bolditalic if available
  },
}

const InspectionPDFDownload = ({
  inspectionDetails,
  pdfModalVisible,
  setPdfModalVisible,
}) => {
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const history = useHistory()
  const dispatch = useDispatch()
  const params = useParams()

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        setLoading(false)
      }, 3000)
    }
  }, [success])

  const sectionContent = inspectionDetails
    ? buildInspectionSectionsContent(
      inspectionSections,
      inspectionDetails,
      getGlobalIndex
    )
    : []
  const handleCloseModal = () => {
    setPdfModalVisible(false)
    setLoading(false)
    setSuccess(false)
  }
  const generatePDF = () => {
    // Helper for safe value

    const safe = v => v || "---"

    // Banner as base64 (if you want to embed images, you must convert them to base64)
    // For now, we'll skip the banner image. If you want to embed, use a base64 string.
    const styles = {
      headerImage: {
        width: 150, // your desired width
      },
    }
    const docDefinition = {
      pageSize: "A4",
      pageMargins: [40, 80, 40, 60],

      // header: (currentPage, pageCount) => ({
      //   image: headerImage,
      //   width: 505,
      //   alignment: "center",
      //   margin: [0, 10, 10, 10],
      // }),
      // footer: function (currentPage, pageCount) {
      //   return {
      //     columns: [
      //       { width: "*", text: "" },
      //       {
      //         image: footerImage,
      //         width: 50,
      //         alignment: "right",
      //       },
      //     ],
      //   }
      // },
      header: function (currentPage, pageCount) {
        if (currentPage === 1) {
          return {
            image: headerImage,
            width: 505,
            alignment: "center",
            margin: [0, 10, 10, 10], // big top margin on first page
          }
        } else if (currentPage === 4) {
          return {
            image: headerImage,
            width: 505,
            alignment: "center",
            margin: [0, 10, 10, 10], // extra top space on page 4
          }
        } else if (currentPage === 7) {
          return {
            image: headerImage,
            width: 505,
            alignment: "center",
            margin: [0, 10, 10, 10], // compact top on page 7
          }
        } else {
          return {
            image: headerImage,
            width: 505,
            alignment: "center",
            margin: [0, 10, 10, 10], // default for other pages
          }
        }
      },
      footer: function (currentPage, pageCount) {
        if (currentPage === 2) {
          return {
            columns: [
              { width: "*", text: "" },
              {
                image: footerImage,
                width: 50,
                alignment: "right",
                margin: [0, 0, 0, 120], // less bottom margin on page 2
              },
            ],
          }
        } else if (currentPage === 7) {
          return {
            columns: [
              { width: "*", text: "" },
              {
                image: footerImage,
                width: 50,
                alignment: "right",
                margin: [0, 0, 0, 100], // large footer on page 7
              },
            ],
          }
        } else {
          return {
            columns: [
              { width: "*", text: "" },
              {
                image: footerImage,
                width: 50,
                alignment: "right",
                margin: [0, 0, 0, 20], // default footer
              },
            ],
          }
        }
      },
      content: [
        // Banner (if you want to use a base64 image, replace the text below)

        // Inspection Info
        {
          columns: [
            {
              width: "25%",
              stack: [
                { text: "Inspection Date", style: "label" },
                // {
                //   text: inspectionDetails?.inspection_data?.inspected_date
                //     ? new Date(
                //         inspectionDetails.inspection_data.inspected_date
                //       ).toLocaleDateString()
                //     : "---",
                //   style: "value",
                //   // bold: true,
                // },
                {
                  text: inspectionDetails?.inspection_data?.inspected_date
                    ? new Date(
                      inspectionDetails.inspection_data.inspected_date
                    ).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    })
                    : "---",
                  style: "value",
                },
              ],
            },
            {
              width: "25%",
              stack: [
                { text: "Inspection No.", style: "label" },
                {
                  text: safe(
                    inspectionDetails?.inspection_data?.inspection_number
                  ),
                  style: "value",
                },
              ],
            },
            {
              width: "25%",
              stack: [
                { text: "Inspected By", style: "label" },
                {
                  text: safe(
                    inspectionDetails?.inspection_data?.inspected_by?.name
                  ),
                  style: "value",
                },
              ],
            },
            {
              width: "25%",
              stack: [
                { text: "Booking No.", style: "label" },
                { text: safe(inspectionDetails?.booking_id), style: "value" },
              ],
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 20],
        },
        // line
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 515,
              y2: 0,
              lineWidth: 1,
              lineColor: "#e0e0e0",
            },
          ],
          margin: [0, 10, 0, 20],
        },
        // Vehicle & Owner Data
        {
          columns: [
            {
              width: "60%",
              stack: [
                // { text: "VEHICLE DATA", style: "sectionHeader" },
                {
                  table: {
                    widths: ["35%", "65%"],

                    body: [
                      [
                        { text: "Vehicle Brand :", style: "label" },
                        {
                          text: safe(
                            inspectionDetails?.vehicle_data?.vehicle_brand?.name
                          ),
                          style: "value",
                          bold: true,
                        },
                      ],
                      [
                        { text: "Reg. No. :", style: "label" },
                        {
                          text: safe(
                            inspectionDetails?.vehicle_data?.vehicle_number
                          ),
                          style: "value",
                          bold: true,
                        },
                      ],
                      [
                        { text: "Vehicle Model :", style: "label" },
                        {
                          text: safe(
                            inspectionDetails?.vehicle_data?.vehicle_model?.name
                          ),
                          style: "value",
                          bold: true,
                        },
                      ],
                      [
                        { text: "Year :", style: "label" },
                        {
                          text: safe(
                            inspectionDetails?.vehicle_data?.vehicle_year
                          ),
                          style: "value",
                        },
                      ],
                      [
                        { text: "Vehicle Variant :", style: "label" },
                        {
                          text: safe(
                            inspectionDetails?.vehicle_data?.vehicle_variant
                              ?.name || inspectionDetails?.vehicle_data?.variant_name
                          ),
                          style: "value",
                        },
                      ],
                      [
                        { text: "KM :", style: "label" },
                        {
                          text: safe(
                            inspectionDetails?.vehicle_data?.current_kilometer
                          ),
                          style: "value",
                        },
                      ],
                      [
                        { text: "Fuel :", style: "label" },
                        {
                          text: safe(
                            inspectionDetails?.vehicle_data?.vehicle_fuel_type
                          ),
                          style: "value",
                        },
                      ],
                      [
                        { text: "Finance :", style: "label" },
                        {
                          text:
                            inspectionDetails?.finance === false ? "No" : "Yes",
                          style: "value",
                        },
                      ],
                    ],
                  },
                  layout: "noBorders",
                  margin: [0, 5, 0, 0],
                },
              ],
            },
            {
              width: "40%",
              stack: [
                // { text: "OWNER DATA", style: "sectionHeader" },
                {
                  table: {
                    widths: ["40%", "60%"],
                    body: [
                      [
                        { text: "Name:", style: "label" },
                        {
                          text: safe(
                            inspectionDetails?.owner_details?.customer_name
                          ),
                          style: "value",
                          bold: true,
                        },
                      ],
                      [
                        { text: "Phone:", style: "label" },
                        {
                          text: safe(
                            inspectionDetails?.owner_details?.phone_number
                          ),
                          style: "value",
                          bold: true,
                        },
                      ],
                      [
                        { text: "State:", style: "label" },
                        {
                          text: safe(
                            inspectionDetails?.owner_details?.state?.name
                          ),
                          style: "value",
                        },
                      ],
                      [
                        { text: "District:", style: "label" },
                        {
                          text: safe(
                            inspectionDetails?.owner_details?.district?.name
                          ),
                          style: "value",
                        },
                      ],
                      [
                        { text: "Address:", style: "label" },
                        {
                          text: safe(inspectionDetails?.owner_details?.address),
                          style: "value",
                        },
                      ],
                    ],
                  },
                  layout: "noBorders",
                  margin: [0, 5, 0, 0],
                },
              ],
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 20],
        },
        // line
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 515,
              y2: 0,
              lineWidth: 1,
              lineColor: "#e0e0e0",
            },
          ],
          margin: [0, 10, 0, 20],
        },
        ...sectionContent,
        ...((inspectionDetails?.replacement_report || inspectionDetails?.remarks)
          ? [
            {
              canvas: [
                {
                  type: "line",
                  x1: 0,
                  y1: 0,
                  x2: 515,
                  y2: 0,
                  lineWidth: 1,
                  lineColor: "#e0e0e0",
                },
              ],
              margin: [0, 10, 0, 30],
            },
            {
              columns: [
                inspectionDetails?.replacement_report ? {
                  width: "50%",
                  stack: [
                    {
                      text: "Replacement Report",
                      style: "sectionHeader",
                    },
                    {
                      text: safe(inspectionDetails.replacement_report),
                      style: "value",
                    },
                  ],
                } : { width: "50%", text: "" },
                inspectionDetails?.remarks ? {
                  width: "50%",
                  stack: [
                    {
                      text: "Remarks",
                      style: "sectionHeader",
                    },
                    {
                      text: safe(inspectionDetails.remarks),
                      style: "value",
                    },
                  ],
                } : { width: "50%", text: "" },
              ],
              columnGap: 10,
              margin: [0, 0, 0, 20],
            },
          ]
          : []),

        // Horizontal line
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 515,
              y2: 0,
              lineWidth: 1,
              lineColor: "#e0e0e0",
            },
          ],
          margin: [0, 10, 0, 10],
        },
        // {
        //   image: verifiedImage,
        //   width: 80,
        //   alignment: "right",
        // },
        // {
        //   image: pdfImage,
        //   width: 80,
        //   alignment: "left",
        // },
        {
          columns: [
            {
              image: qrImage,
              width: 60,
              alignment: "left",
            },
            { width: "*", text: "" },
            {
              image: verifiedImage,
              width: 80,
              alignment: "right",
            },
          ],
        },

        // Verified image (if you want to embed, use base64 string)
        // {
        //   text: "Verified",
        //   alignment: "right",
        //   italics: true,
        //   fontSize: 12,
        //   margin: [0, 10, 0, 0],
        // },
      ],
      styles: {
        sectionHeader: {
          font: "SpaceGrotesk",
          fontSize: 13,
          bold: true,
          margin: [0, 10, 0, 10],
          fillColor: "#e9ecef", // darker shade
          color: "#212529",
        },
        label: {
          fontSize: 10,
          color: "#888",
          margin: [0, 2, 0, 0],
        },
        value: {
          fontSize: 11,
          color: "black",
          margin: [0, 0, 0, 4],
        },
        // tableIndex: {
        //   fontSize: 10,
        //   margin: [0, 0, 2, 0], // reduce or remove right margin
        // },
      },
      defaultStyle: {
        font: "SpaceGrotesk",
      },
    }

    return new Promise(resolve => {
      pdfMake.createPdf(docDefinition).getBase64(async base64 => {
        try {
          const response = await post("/media/admin/upload/inspection-reports", {
            file: `data:application/pdf;base64,${base64}`,
            original_name: "inspection-report.pdf",
          })

          const uploadedUrl = response
          if (uploadedUrl) {
            const inspection = {
              pdf_url: uploadedUrl,
              inspection_data: {
                inspection_number: params?.id,
                inspected_by: inspectionDetails?.inspection_data?.inspected_by,
                inspected_date: inspectionDetails?.inspection_data
                  ?.inspected_date
                  ? moment(
                    inspectionDetails.inspection_data.inspected_date
                  ).format("YYYY-MM-DD")
                  : "",
              },
            }

            // ✅ Now update the inspection with new PDF URL
            // dispatch(
            //   updateInspection(
            //     inspection,
            //     inspectionDetails?._id,
            //     history,
            //     handleCloseModal,
            //     setSuccess
            //   )
            // )
            dispatch(
              updateInspection(
                inspection,
                inspectionDetails?._id,
                history,
                setSuccess,
                // handleCloseModal
                () => {
                  // Don’t close the modal here immediately
                  setSuccess(true)
                  setLoading(false)

                  // Close modal after a short delay (optional)
                  setTimeout(() => {
                    handleCloseModal()
                  }, 4000)
                }
              )
            )
          }
        } catch (error) {
          // console.error("Upload error:", error)
        }
      })
    })
  }
  const onClickButton = () => {
    setPdfModalVisible(true)
    setLoading(true)

    window.requestAnimationFrame(() => {
      setTimeout(async () => {
        await generatePDF()
        setLoading(false)
      }, 1000)
    })
  }

  return (
    <>
      <InspectionPDFDownloadModal
        // show={loading}
        show={pdfModalVisible}
        setSuccess={setSuccess}
        success={success}
        loading={loading}
        inspectionDetails={inspectionDetails}
        onCloseClick={handleCloseModal}
      />

      <Button
        onClick={onClickButton}
        // onClick={onClickModal}
        color="warning rounded-pill px-4"
        outline
        disabled={loading}
      >
        <FaFilePdf className="me-1" />{" "}
        {inspectionDetails?.pdf_url?.url
          ? "Regenerate Inspection Report"
          : "Generate Inspection Report"}
      </Button>
    </>
  )
}

InspectionPDFDownload.propTypes = {
  inspectionDetails: PropTypes.object.isRequired,
  pdfModalVisible: PropTypes.any,
  setPdfModalVisible: PropTypes.any,
}

export default InspectionPDFDownload
